import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentPage, setPageSize } from "../../../redux/znsEvent/znsEvent";
import {
  deleteChangePointSetting,
  getListChangePointSetting,
  updateChangePointSetting,
} from "../../../api/ChangePoint/changePointSetting";
import { NavLink } from "react-router-dom";
import {
  SaveOutlined,
  CloseOutlined,
  PlusCircleOutlined,
} from "@ant-design/icons";
import {
  Breadcrumb,
  Button,
  Divider,
  Empty,
  Table,
  Spin,
  Form,
  Input,
  message,
  Col,
  Row,
  InputNumber,
  Card,
} from "antd";
import FormAddChangePointSetting from "./FormAddChangePointSetting";
import RowActions from "../../../components/cms/RowActions";
import { ACTION_ICON, confirmDelete } from "../../../components/cms/actions";
import { neutral } from "../../../theme/tokens";

export default function ChangePointSettingTable() {
  const {
    listChangePointSetting,
    isLoadChangePointSetting,
    currentPage,
    pageSize,
    totalRecords,
  } = useSelector((state) => state.persistedReducer.changePointSettingSlice);

  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();
  const [editingKey, setEditingKey] = useState("");
  const [editedRecord, setEditedRecord] = useState({});

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = useCallback(() => {
    setIsModalOpen(false);
  }, [setIsModalOpen]);

  useEffect(() => {
    dispatch(getListChangePointSetting({ currentPage, pageSize }));
  }, [dispatch, currentPage, pageSize]);

  const handlePageChange = (page) => {
    dispatch(setCurrentPage(page));
  };

  const handleSizeChange = useCallback(
    (current, size) => {
      setPageSize(size);
    },
    [setPageSize]
  );

  // Kiểm tra xem dòng có đang được chỉnh sửa không
  const isEditing = (record) => record.id === editingKey;

  // Bắt đầu chỉnh sửa
  const edit = (record) => {
    form.setFieldsValue({ ...record });
    setEditingKey(record.id);
    setEditedRecord(record);
  };

  // Hủy chỉnh sửa
  const cancel = () => {
    setEditingKey("");
  };

  // Lưu dữ liệu đã chỉnh sửa
  const save = async (id) => {
    try {
      const row = await form.validateFields();
      // const updatedData = { ...row };
      const updatedData = {
        ...row,
        transaction_fee: parseFloat(row.transaction_fee),
        minimum_balance: parseFloat(row.minimum_balance),
      };
      const response = await dispatch(
        updateChangePointSetting({ id, data: updatedData })
      );
      if (updateChangePointSetting.fulfilled.match(response)) {
        message.success("Cập nhât dữ liệu thành công!");
        await dispatch(getListChangePointSetting({ currentPage, pageSize }));
      } else if (updateChangePointSetting.rejected.match(response)) {
        if (response.payload.message) {
          message.error(response.payload.message);
        }
        if (response.payload.errors) {
          Object.keys(response.payload.errors).forEach((field) => {
            const errorMessages = response.payload.errors[field];
            errorMessages.forEach((errorMessage) => {
              message.error(`${errorMessage}`);
            });
          });
        }
      }
      setEditingKey("");
    } catch (err) {
      console.error("Có lỗi xảy ra:", err);
    }
  };

  const deleteEventRecord = async (id) => {
    try {
      await dispatch(deleteChangePointSetting(id));
      dispatch(getListChangePointSetting({ currentPage, pageSize }));
    } catch (err) {
      console.error("Error deleting service:", err);
    }
  };

  // Định nghĩa các cột cho bảng
  const columns = [
    {
      title: "Chi nhánh",
      dataIndex: "mcoupon_branch_id",
      key: "mcoupon_branch_id",
      width: "25%",
      render: (_, record) => record.branch?.name || "Không có dữ liệu",
    },
    {
      title: "Số dư tối thiểu (Điểm)",
      dataIndex: "minimum_balance",
      key: "minimum_balance",
      width: "25%",
      render: (_, record) =>
        isEditing(record) ? (
          <Form.Item
            name="minimum_balance"
            style={{ margin: 0 }}
            rules={[
              { required: true, message: "Vui lòng nhập số dư tối thiểu" },
            ]}
          >
            <InputNumber
              placeholder="Nhập số dư tối thiểu"
              style={{ width: "100%" }}
              min={0}
              formatter={(value) =>
                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(value) => value.replace(/,/g, "")}
            />
          </Form.Item>
        ) : (
          record.minimum_balance
        ),
      // render: (_, record) =>
      //   isEditing(record) ? (
      //     <Form.Item
      //       name="minimum_balance"
      //       style={{ margin: 0 }}
      //       rules={[
      //         { required: true, message: "Vui lòng nhập số dư tối thiểu" },
      //         {
      //           min: 0,
      //           message: "Số dư tối thiểu phải lớn hơn hoặc bằng 0",
      //         },
      //       ]}
      //     >
      //       <InputNumber
      //         placeholder="Nhập số dư tối thiểu"
      //         style={{ width: "100%" }}
      //         min={0}
      //         formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
      //         parser={(value) => value.replace(/,/g, "")}
      //       />
      //     </Form.Item>
      //   ) : (
      //     record.minimum_balance?.toLocaleString()
      //   ),
    },
    {
      title: "Phí giao dịch (%)",
      dataIndex: "transaction_fee",
      key: "transaction_fee",
      width: "25%",
      render: (_, record) =>
        isEditing(record) ? (
          <Form.Item
            name="transaction_fee"
            style={{ margin: 0 }}
            rules={[{ required: true, message: "Vui lòng nhập phí giao dịch" }]}
          >
            <InputNumber
              placeholder="Nhập phí giao dịch"
              style={{ width: "100%" }}
              min={0}
              max={100}
              step={0.01}
            />
          </Form.Item>
        ) : (
          // record.transaction_fee
          `${record.transaction_fee}%`
        ),
      // render: (_, record) =>
      //   isEditing(record) ? (
      //     <Form.Item
      //       name="transaction_fee"
      //       style={{ margin: 0 }}
      //       rules={[
      //         { required: true, message: "Vui lòng nhập phí giao dịch" },
      //         { min: 0, max: 100, message: "Phí phải từ 0 đến 100%" },
      //       ]}
      //     >
      //       <InputNumber
      //         placeholder="Nhập phí giao dịch"
      //         style={{ width: "100%" }}
      //         min={0}
      //         max={100}
      //         step={0.01}
      //         formatter={(value) => `${value}%`}
      //         parser={(value) => value.replace("%", "")}
      //       />
      //     </Form.Item>
      //   ) : (
      //     `${record.transaction_fee}%`
      //   ),
    },
    {
      title: "Thao tác",
      dataIndex: "operation",
      align: "center",
      width: "25%",
      render: (_, record) => {
        const editable = isEditing(record); // Kiểm tra nếu dòng đang chỉnh sửa
        return editable ? (
          <>
            <Button
              type="link"
              icon={<SaveOutlined />}
              onClick={() => save(record.id)} // Lưu dữ liệu
              style={{ marginRight: 8 }}
            >
              Lưu
            </Button>
            <Button
              type="link"
              icon={<CloseOutlined />}
              onClick={cancel} // Hủy chỉnh sửa
              danger
              style={{ color: neutral[500] }}
            >
              Hủy
            </Button>
          </>
        ) : (
          <RowActions
            disabled={editingKey !== ""}
            items={[
              {
                key: "edit",
                icon: ACTION_ICON.edit,
                label: "Chỉnh sửa",
                onClick: () => edit(record),
              },
              {
                key: "delete",
                icon: ACTION_ICON.delete,
                label: "Xóa thiết lập",
                danger: true,
                divider: true,
                onClick: () =>
                  confirmDelete(`thiết lập #${record.id}`, () =>
                    deleteEventRecord(record.id)
                  ),
              },
            ]}
          />
        );
      },
    },
  ];

  return (
    <div>
      <div className="bg-gray-50 min-h-screen p-6">
        <Card className="mb-6 shadow-sm">
          <Breadcrumb separator=">">
            <Breadcrumb.Item>Trang chủ</Breadcrumb.Item>
            <Breadcrumb.Item>Cài đặt</Breadcrumb.Item>
            <Breadcrumb.Item>
              <NavLink to="/change-point-setting">
                Thiết lập cấu hình gửi điểm
              </NavLink>
            </Breadcrumb.Item>
          </Breadcrumb>

          <p style={{ fontSize: "12px", color: "#555" }}>
            Trang <strong>"Thiết Lập Cấu Hình Gửi Điểm"</strong> cho phép quản
            trị viên cấu hình tỷ lệ chi phí khi khách hàng gửi điểm từ một tài
            khoản này sang tài khoản khác. Chi phí này có thể tính theo tỷ lệ
            phần trăm của số điểm gửi đi, giúp kiểm soát các giao dịch và tối ưu
            hóa việc sử dụng điểm thưởng trong hệ thống.
          </p>
          <Divider />

          <Row gutter={[16, 16]}>
            <Col xl lg md sm>
              <Button
                type="primary"
                onClick={showModal}
                icon={<PlusCircleOutlined />}
              >
                Thêm mới
              </Button>
              <FormAddChangePointSetting
                isModalOpen={isModalOpen}
                currentPage={currentPage}
                pageSize={pageSize}
                handleOk={handleOk}
                handleCancel={handleCancel}
              />
            </Col>
          </Row>
          <Divider />

          <Form form={form} component={false}>
            <Table
              columns={columns}
              loading={
                listChangePointSetting?.length === 0
                  ? isLoadChangePointSetting
                  : false
              }
              dataSource={
                isLoadChangePointSetting ? [] : listChangePointSetting
              } // Dữ liệu hiển thị trong bảng
              rowKey="id"
              pagination={{
                showTotal: (totalRecords, range) =>
                  `Hiển thị từ ${range[0]} -> ${range[1]} trong tổng ${totalRecords} giá trị`,
                showQuickJumper: true,
                showSizeChanger: true,
                onShowSizeChange: handleSizeChange,
                total: totalRecords,
                current: currentPage,
                onChange: handlePageChange,
                pageSizeOptions: [10, 20, 30],
              }}
              locale={{
                emptyText: <Empty description="Không có sự kiện!" />,
              }}
              scroll={{ x: 'max-content' }}
            />
          </Form>
        </Card>
      </div>
    </div>
  );
}
